/// CORE ///
import { NgModule, inject } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

/// COMPONENTS ///
import { HomeComponent } from './pages/home/home.component'
import { StatistiquesComponent } from './pages/statistiques/statistiques.component'
import { LoginComponent } from './pages/login/login.component'

////    GUARDS    ////
import { AuthGuard } from 'src/auth/auth.guard'
import { MarketComponent } from './components/market/market.component'
import { EditMarketComponent } from './components/edit-market/edit-market.component'
import { EditTypeSupportComponent } from './components/edit-type-support/edit-type-support.component'

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'documents',
    component: HomeComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'documents/:id',
    component: MarketComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'marche/:id',
    component: EditMarketComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'marche/creation',
    component: EditMarketComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'type-support/creation/:id',
    component: EditTypeSupportComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'type-support/edition/:id',
    component: EditTypeSupportComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  {
    path: 'statistiques',
    component: StatistiquesComponent,
    canActivate: [AuthGuard],
    data: { feature: [] }
  },
  { path: 'login', component: LoginComponent },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
